export { default as translations } from './translations.json';

export const DEFAULT_THRESHOLD = parseInt(
  typeof process !== 'undefined' ? (process.env?.INVENTORY_ALERT_THRESHOLD || '5') : '5',
  10
);

/**
 * Get alert threshold for a listing.
 * @param {Object|null} listing
 * @returns {number}
 */
export const getAlertThreshold = (listing) =>
  listing?.attributes?.publicData?.stockAlertThreshold ?? DEFAULT_THRESHOLD;

/**
 * Check if stock is below threshold.
 * @param {number|null} currentStock
 * @param {number} threshold
 * @returns {boolean}
 */
export const isLowStock = (currentStock, threshold) =>
  currentStock !== null && currentStock !== undefined && currentStock <= threshold;
